import React from "react";
import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

const SearchLimitBanner = ({
    showWarning,
    isLimitReached,
    planTier,
    planBaseTier,
    searchLimit,
    remainingSearches
}) => {
    const navigate = useNavigate();

    if (!showWarning && !isLimitReached) return null;

    return (
        <div className={`border-b px-6 py-4 flex items-center justify-between animate-fadeIn ${isLimitReached
            ? "bg-red-50 border-red-200"
            : "bg-orange-50 border-orange-100"
            }`}>
            <div className="flex items-center space-x-3">
                <div className={`p-2 rounded-full ${isLimitReached ? "bg-red-100" : "bg-orange-100"}`}>
                    {isLimitReached ? (
                        <Lock className="w-5 h-5 text-red-600" />
                    ) : (
                        <Lock className="w-5 h-5 text-orange-600" />
                    )}
                </div>
                <div className="flex flex-col">
                    <span className={`text-sm font-bold ${isLimitReached ? "text-red-900" : "text-orange-900"}`}>
                        {isLimitReached ? `${planTier} Search Limit Reached` : `${planTier} Plan — Search Limit Warning`}
                    </span>
                    <span className={`text-xs font-medium ${isLimitReached ? "text-red-700" : "text-orange-700"}`}>
                        {isLimitReached ? (
                            `You've used all ${searchLimit} monthly searches on your ${planTier} plan. Upgrade to increase your limit.`
                        ) : (
                            <>
                                You have <span className="font-bold">{remainingSearches}</span> {remainingSearches === 1 ? 'search' : 'searches'} remaining on your {planTier} plan.
                            </>
                        )}
                    </span>
                </div>
            </div>
            {isLimitReached && planBaseTier !== 'Professional' && (
                <button
                    onClick={() => navigate('/#subscription-plans')}
                    className={`text-xs font-bold px-4 py-2 rounded-xl border-2 transition-all transform hover:scale-105 shadow-sm ${isLimitReached
                        ? "bg-red-600 text-white border-red-600 hover:bg-red-700 hover:shadow-red-500/20"
                        : "bg-white text-orange-600 border-orange-200 hover:bg-orange-50"
                        }`}
                >
                    {planTier === 'Free' ? 'Upgrade to Pro' : 'Upgrade Plan'}
                </button>
            )}
            {!isLimitReached && (
                <button
                    onClick={() => navigate('/#subscription-plans')}
                    className="text-xs font-bold px-4 py-2 rounded-xl border-2 transition-all transform hover:scale-105 shadow-sm bg-white text-orange-600 border-orange-200 hover:bg-orange-50"
                >
                    Upgrade Now
                </button>
            )}
            {isLimitReached && planBaseTier === 'Professional' && (
                <a
                    href="mailto:support@developmentanalyzer.com"
                    className="text-xs font-bold px-4 py-2 rounded-xl border-2 transition-all transform hover:scale-105 shadow-sm bg-slate-700 text-white border-slate-700 hover:bg-slate-800"
                >
                    Contact Support
                </a>
            )}
        </div>
    );
};

export default SearchLimitBanner;
